import { leashContentKey } from 'leash/utilities/localStorage/leashContentStorage';
import { pricingContentKey } from 'pricing/utilities/localStorage/pricingContentStorage';
import { pupDocsContentKey } from 'pupdocs/utilities/localStorage/pupDocsContentStorage';
import { User } from 'types';

export const userToken = 'userToken';
export const userInformation = 'userInformation';

const userStorage = {
  setToken(token: string) {
    localStorage.setItem(userToken, token);
  },

  getToken() {
    return localStorage.getItem(userToken);
  },

  setUser(user: User) {
    localStorage.setItem(userInformation, JSON.stringify(user));
  },

  removeUserAndToken() {
    localStorage.removeItem(userInformation);
    localStorage.removeItem(userToken);
    localStorage.removeItem(pricingContentKey);
    localStorage.removeItem(leashContentKey);
    localStorage.removeItem(pupDocsContentKey);
  },

  getUser(): User | null {
    const userInfo = localStorage.getItem(userInformation);
    if (userInfo) {
      return JSON.parse(userInfo);
    }
    return null;
  },
};

export default userStorage;
